/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getBuilderNodesMetadata } from '../api/botsApi';

const IndicatorMetadataContext = createContext();

export const useIndicatorMetadata = () => useContext(IndicatorMetadataContext);

export const IndicatorMetadataProvider = ({ children }) => {
  const [indicatorMetadata, setIndicatorMetadata] = useState([]);
  const [operatorMetadata, setOperatorMetadata] = useState([]);
  const [actionMetadata, setActionMetadata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMetadata = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        const { indicators, operators, actions } = await getBuilderNodesMetadata({});
        setIndicatorMetadata(indicators);
        setOperatorMetadata(operators);
        setActionMetadata(actions);
      } catch (err) {
        setError(err);
        console.error("Failed to fetch metadata:", err);
      } finally {
        setIsLoading(false);
      }
    };

    loadMetadata();
  }, []);

  const value = {
    indicatorMetadata,
    operatorMetadata,
    actionMetadata,
    isLoading,
    error,
  };

  return (
    <IndicatorMetadataContext.Provider value={value}>
      {children}
    </IndicatorMetadataContext.Provider>
  );
};
